import { render, staticRenderFns } from "./JobProfileCard.vue?vue&type=template&id=a680cf9c&scoped=true&"
import script from "./JobProfileCard.vue?vue&type=script&lang=js&"
export * from "./JobProfileCard.vue?vue&type=script&lang=js&"
import style0 from "./JobProfileCard.vue?vue&type=style&index=0&id=a680cf9c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a680cf9c",
  null
  
)

export default component.exports